<template>
  <div class="zSteps zSteps-many">
    <div :class="prefixCls + '-common'">
      <Steps :current="step">
        <Step :title="item.title" v-for="(item, k) in orderSteps" :key="k">
          <div class="step-small">
            <div
              class="step-small-main"
              v-if="
                k === step || (orderSteps.length === step && k + 1 === step)
              "
            >
              <div class="triangle"></div>
            </div>
          </div>

          <div
            class="pointer-text"
            v-if="
              k === 2 &&
                ordersDetail &&
                step >= 2 &&
                ordersDetail.actualAmount > 0 &&
                ordersDetail.actualAmount < ordersDetail.receiveAmount
            "
          >
            <Tooltip
              class="step-many-tootip"
              placement="right"
              style="left:5px;"
              content="等待您结清剩余款项"
              always
              theme="light"
            >
              <span></span>
            </Tooltip>
          </div>
        </Step>
      </Steps>

      <div class="slot-details">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
const prefixCls = "zSteps";
export default {
  name: "ZStepMany",
  data() {
    return {
      prefixCls: prefixCls,
      indexVal: 0,
      switchLoop: {
        loop: false,
        autoplay: false,
        loopData: []
      }
    };
  },
  props: {
    step: {
      type: Number,
      default: 1
    },
    /* 二维数组 */
    orderSteps: {
      type: Array,
      default: function() {
        return [];
      }
    },
    /* 订单详情 */
    ordersDetail: {
      type: [Array, Object],
      default: function() {
        return "";
      }
    }
  },
  computed: {
    activeClass() {
      return `${this.prefixCls}-active`;
    },
    activeLine() {
      return `${this.prefixCls}-line`;
    }
  },
  methods: {
    nextChar(c) {
      return String.fromCharCode(c.charCodeAt(0) + 1);
    },

    /* 处理小状态的数据问题 */
    setGuideDetailList(list, code) {
      if (!list || list.length === 0) return false;
      let newLists = [];
      let codeat = code;
      list.forEach((item, index) => {
        if (index + 1 < list.length) {
          this.$set(item, "codeat", codeat);
          newLists.push(item);
          newLists.push("line");
        } else {
          this.$set(item, "codeat", codeat);
          newLists.push(item);
        }
        codeat = this.nextChar(codeat);
      });
      return newLists;
    },

    /* 小状态进行的步奏 */
    smallStatus(item, guideDetailList) {
      if (guideDetailList.status === 200) {
        return "red";
      }
      if (item.status === 200) {
        // if (guideDetailList.status === 200) {
        //   return "red";
        // } else
        if (guideDetailList.status === 100) {
          return "future";
        }
      } else if (item.status === 100) {
        return "future";
      }
    }
  },
  created() {
    if (this.orderSteps.length > 0 && this.orderSteps.length <= 1) {
      this.switchLoop.loop = false;
      this.switchLoop.autoplay = false;
    } else if (this.orderSteps.length > 0 && this.orderSteps.length > 1) {
      this.switchLoop.loop = true;
      this.switchLoop.autoplay = true;
    }
    /* 完成的由数字替换 */
    this.$nextTick().then(() => {
      let dom = document.getElementsByClassName("ivu-icon-ios-checkmark");
      dom = [...dom];
      dom.forEach((element, index) => {
        let para = document.createTextNode(index + 1);
        element.appendChild(para);
      });
    });
  }
};
</script>
